import StaticResume from './StaticResume';
import LiveAPIResume from './LiveAPIResume';

export default function ResumeComparison() {
  return (
    <section id="comparison" className="space-y-8">
      {/* Section header */}
      <div>
        <h2 className="text-3xl font-bold text-ti-text mb-2">
          PDF vs API: The Indexing Advantage
        </h2>
        <p className="text-ti-text-muted max-w-2xl">
          Two representations of the same person. One is parseable by machines,
          queryable by agents, and always up to date. The other is not.
        </p>
      </div>

      {/* Callout */}
      <div className="bg-ti-surface border border-ti-border rounded-xl px-6 py-4 text-center">
        <p className="text-ti-text-muted leading-relaxed">
          <span className="text-ti-text font-medium">One is a document frozen in time.</span>{' '}
          The other is a living, queryable, machine-readable data source that any AI agent can consume.
        </p>
      </div>

      {/* Comparison columns */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left: Static Resume */}
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-ti-red" />
            <h3 className="text-sm font-semibold text-ti-text-dim uppercase tracking-wider">
              The Resume (Static PDF)
            </h3>
          </div>
          <StaticResume />
        </div>

        {/* Right: Live API Resume */}
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-ti-green opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-ti-green" />
            </span>
            <h3 className="text-sm font-semibold text-ti-text-dim uppercase tracking-wider">
              The Living Resume (API)
            </h3>
          </div>
          <LiveAPIResume />
        </div>
      </div>
    </section>
  );
}
